// Modern ES6+ imports
console.log("📁 Script file loaded");

import { gsap } from "gsap";
import { Splide } from "@splidejs/splide";
import { Video } from "@splidejs/splide-extension-video";

import anime from "animejs";
import Accordion from "accordion-js";
// import Tabby from 'tabbyjs';
import GLightbox from "glightbox";
import intlTelInput from "intl-tel-input";

import { Phonenumber } from "./phonenumber.js";

// Your main app
class TongkolspaceApp {
  constructor() {
    console.log("🚀 Tongkolspace App Initialized wakkakk");

    this.init();
  }

  init() {
    console.log("🚀 Tongkolspace App Initialized wakkakk");
    this.initAnimations();
    this.initSliders();
    this.initAccordions();
    this.initTabs();
    this.initLightbox();
    this.initNavigation();
    this.initVideoPopup(); // Add video popup initialization
    this.openSearchHeader();
    this.initDownloadLinks();
    this.initPhonenumber();
    this.initModal();
    this.initCarousel();
    this.initMobileSidebarTabs();
    this.initIntl();
    this.initCardAboutBrand();

    this.initMoreContent();
    this.initMobileClick();
  }


  initMobileClick() {
    if (this.isMobile()) {
      // Menggunakan querySelectorAll untuk memilih semua elemen
      const cardMobiles = document.querySelectorAll('.cardLang');

      cardMobiles.forEach(card => {
        const triggerMobile = card.querySelector('.cardLang__header');

        if (triggerMobile) {
          // Menghapus event hover dari card parent
          card.removeEventListener('mouseenter', this.hoverHandler);
          card.removeEventListener('mouseleave', this.hoverHandler);

          // Menambahkan event click untuk toggle class active pada card parent
          triggerMobile.addEventListener('click', () => {
            card.classList.toggle('active');
          });
        }
      });
    }
  }

  initMoreContent() {
    // if (this.isMobile()) {
    function initExpandableText(selector, maxLines = 4) {
      // Cari semua element berdasarkan selector
      const cardElements = document.querySelectorAll(selector);

      if (cardElements.length === 0) {
        console.error("Card element tidak ditemukan");
        return;
      }

      // Proses setiap card element
      cardElements.forEach((cardElement, index) => {
        const textElement = cardElement.querySelector(".cardStory__content");
        const btnElement = cardElement.querySelector(
          ".cardStory__action .btn"
        );

        if (!textElement || !btnElement) {
          console.error(
            `Content atau button element tidak ditemukan pada card index ${index}`
          );
          return;
        }

        // Fungsi untuk menghitung jumlah baris
        function getLineCount(element) {
          const computedStyle = window.getComputedStyle(element);
          const lineHeight = parseFloat(computedStyle.lineHeight);

          // Buat clone element untuk mengukur tinggi penuh
          const clone = element.cloneNode(true);
          clone.style.height = "auto";
          clone.style.maxHeight = "none";
          clone.style.webkitLineClamp = "none";
          clone.style.display = "block";
          clone.style.visibility = "hidden";
          clone.style.position = "absolute";
          clone.style.width = element.offsetWidth + "px";

          element.parentNode.appendChild(clone);
          const fullHeight = clone.scrollHeight;
          element.parentNode.removeChild(clone);

          // console.log(fullHeight+ "--" + lineHeight);


          // return Math.ceil(fullHeight / lineHeight);
          return Math.ceil(fullHeight / 32);
        }

        // Fungsi untuk toggle teks
        function toggleText() {
          if (cardElement.classList.contains("show")) {
            cardElement.classList.remove("show");
          } else {
            cardElement.classList.add("show");
          }
        }

        // Inisialisasi untuk element ini
        function init() {
          // Reset classes
          cardElement.classList.remove("noMore", "addMore", "show");

          // Hitung jumlah baris
          const lineCount = getLineCount(textElement);

          if (lineCount <= maxLines) {
            // Kurang dari atau sama dengan maxLines
            cardElement.classList.add("noMore");
          } else {
            // Lebih dari maxLines
            cardElement.classList.add("addMore");
          }
        }

        // Event listener untuk tombol (gunakan arrow function untuk preserve context)
        const clickHandler = (e) => {
          e.preventDefault();
          toggleText();
        };

        // Remove existing listener jika ada (prevent duplicate)
        btnElement.removeEventListener("click", clickHandler);
        btnElement.addEventListener("click", clickHandler);

        // Inisialisasi
        init();

        // Store resize handler untuk cleanup jika diperlukan
        const resizeHandler = () => init();

        // Remove existing resize listener untuk element ini
        window.removeEventListener("resize", resizeHandler);
        window.addEventListener("resize", resizeHandler);
      });
    }

    // Jalankan setelah DOM loaded atau langsung jika DOM sudah ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        // Untuk multiple elements dengan class .cardStory
        initExpandableText(".cardStory", 4);
      });
    } else {
      // DOM sudah ready, jalankan langsung
      initExpandableText(".cardStory", 4);
    }
    // }
  }

  initCardAboutBrand() {
    const cardAboutBrands = document.querySelectorAll(".cardAboutBrand");

    cardAboutBrands.forEach((card) => {
      const maxItems = parseInt(card.dataset.max) || 10;
      const gridItems = card.querySelectorAll(".cardAboutBrand__grid5-list");
      const actionBtn = card.querySelector(".cardAboutBrand__action");

      if (gridItems.length > maxItems) {
        // Sembunyikan item yang melebihi batas secara langsung
        card.classList.add("with-action");
        gridItems.forEach((item, index) => {
          if (index >= maxItems) {
            item.classList.add("hide-item");
          }
        });

        actionBtn.addEventListener("click", () => {
          if (card.classList.contains("expanded")) {
            // Sembunyikan kembali
            gridItems.forEach((item, index) => {
              if (index >= maxItems) {
                item.classList.add("hide-item");
              }
            });
            card.classList.remove("expanded");
          } else {
            // Tampilkan semua
            gridItems.forEach((item) => {
              item.classList.remove("hide-item");
            });
            card.classList.add("expanded");
          }
        });
      } else {
        actionBtn.classList.add("hide");
      }
    });
  }

  initMobileSidebarTabs() {
    if (!this.isMobile()) return;

    this.dropdowns = document.querySelectorAll(".dropdown-container ul");

    this.dropdowns.forEach((dropdown) => {
      const firstLi = dropdown.querySelector("li:first-child");
      if (!firstLi) return;

      const firstLink = firstLi.querySelector("a");
      if (!firstLink) return;

      // Duplikat firstLi untuk header/trigger
      const headerLi = firstLi.cloneNode(true);
      headerLi.classList.add("dropdown-header");

      // Insert header sebelum firstLi
      dropdown.insertBefore(headerLi, firstLi);

      // Hide original firstLi
      // firstLi.style.display = "none";

      const allLinks = dropdown.querySelectorAll(
        "li:not(.dropdown-header):not(:first-child) a"
      );

      // Toggle dropdown - gunakan headerLi sebagai trigger
      headerLi.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDropdown(dropdown);
      });

      // Handle item selection
      allLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          this.selectDropdownItem(dropdown, link, headerLi.querySelector("a"));
        });
      });
    });

    this.setupGlobalListeners();
  }

  toggleDropdown(currentDropdown) {
    // Close other dropdowns
    this.dropdowns.forEach((dropdown) => {
      if (dropdown !== currentDropdown) {
        dropdown.classList.remove("open");
      }
    });

    // Toggle current
    currentDropdown.classList.toggle("open");
  }

  selectDropdownItem(dropdown, selectedLink, headerLink) {
    // Update active state
    dropdown.querySelectorAll("a").forEach((a) => {
      a.classList.remove("active");
      a.setAttribute("aria-selected", "false");
    });

    selectedLink.classList.add("active");
    selectedLink.setAttribute("aria-selected", "true");

    // Update header text
    headerLink.textContent = selectedLink.textContent.trim();
    headerLink.setAttribute("href", selectedLink.getAttribute("href"));
    headerLink.setAttribute(
      "data-tabby",
      selectedLink.getAttribute("data-tabby")
    );

    // Close dropdown
    dropdown.classList.remove("open");

    console.log("Selected:", selectedLink.textContent.trim());
  }

  setupGlobalListeners() {
    this.outsideClickHandler = (e) => {
      if (!e.target.closest(".dropdown-container")) {
        this.closeAllDropdowns();
      }
    };

    document.addEventListener("click", this.outsideClickHandler);
  }

  closeAllDropdowns() {
    this.dropdowns.forEach((dropdown) => dropdown.classList.remove("open"));
  }

  // initMobileSidebarTabs() {
  //   if (this.isMobile()) {
  //     // Find all dropdown containers
  //     const dropdowns = document.querySelectorAll(".dropdown-container ul");

  //     dropdowns.forEach((dropdown) => {
  //       const firstLi = dropdown.querySelector("li:first-child");
  //       const firstLink = firstLi.querySelector("a");
  //       const allLinks = dropdown.querySelectorAll("li:not(:first-child) a");

  //       // Toggle dropdown
  //       firstLi.addEventListener("click", function (e) {
  //         e.preventDefault();

  //         // Close other dropdowns
  //         dropdowns.forEach((other) => {
  //           if (other !== dropdown) other.classList.remove("open");
  //         });

  //         // Toggle current dropdown
  //         dropdown.classList.toggle("open");
  //       });

  //       // Handle item selection
  //       allLinks.forEach((link) => {
  //         link.addEventListener("click", function (e) {
  //           e.preventDefault();

  //           // Update active state
  //           dropdown.querySelectorAll("a").forEach((a) => {
  //             a.classList.remove("active");
  //             a.setAttribute("aria-selected", "false");
  //           });

  //           this.classList.add("active");
  //           this.setAttribute("aria-selected", "true");

  //           // Update header text
  //           firstLink.textContent = this.textContent.trim();
  //           firstLink.setAttribute("href", this.getAttribute("href"));
  //           firstLink.setAttribute("data-tabby", this.getAttribute("data-tabby"));

  //           // Close dropdown
  //           dropdown.classList.remove("open");

  //           console.log("Selected:", this.textContent.trim());
  //         });
  //       });
  //     });

  //     // Close dropdown when clicking outside
  //     document.addEventListener("click", function (e) {
  //       if (!e.target.closest(".dropdown-container")) {
  //         dropdowns.forEach((dropdown) => {
  //           dropdown.classList.remove("open");
  //         });
  //       }
  //     });

  //     // Close on Escape key
  //     document.addEventListener("keydown", function (e) {
  //       if (e.key === "Escape") {
  //         dropdowns.forEach((dropdown) => {
  //           dropdown.classList.remove("open");
  //         });
  //       }
  //     });
  //   }
  // }

  initPhonenumber() {
    const phoneApp = new Phonenumber();
  }

  initAnimations() {
    // GSAP animations
    // gsap.from('.fade-in', {
    //   duration: 1,
    //   y: 50,
    //   opacity: 0,
    //   stagger: 0.2
    // });
    // // Anime.js animations
    // anime({
    //   targets: '.slide-in',
    //   translateX: [-100, 0],
    //   opacity: [0, 1],
    //   duration: 800,
    //   delay: anime.stagger(100)
    // });
  }

  initLightbox() {
    // Cek apakah ada element glightbox
    const lightboxElements = document.querySelectorAll(".glightbox");

    if (lightboxElements.length > 0) {
      const lightbox = GLightbox({
        selector: ".glightbox", // ✅ String selector, bukan NodeList
        touchNavigation: true,
        loop: true,
        width: "90vw",
        height: "90vh",
        videosWidth: "70vw",
        beforeSlideChange: (slide, data) => {
          console.log("Slide changed");
        },
      });

      console.log(
        "GLightbox initialized with",
        lightboxElements.length,
        "elements"
      );
    } else {
      console.log("No glightbox elements found");
    }
  }

  initSliders() {
    console.log("Tongkolspace App Initialized wakkakk-=========");
    // Splide sliders
    const programStudySlider = document.querySelectorAll(".programStudySlider");
    programStudySlider.forEach((element) => {
      new Splide(element, {
        perPage: 4,
        gap: "24px",
        breakpoints: {
          991: {
            perPage: 1,
            drag: false, // Disables dragging
          },
        },
      }).mount();
    });

    // Splide sliders
    const slideHeroNews = document.querySelectorAll(".slideHeroNews");
    slideHeroNews.forEach((element) => {
      new Splide(element, {
        perPage: 1,
        gap: "24px",
      }).mount();
    });

    // Splide sliders
    const splideHeroSlider = document.querySelectorAll(".splideHeroSlider");
    splideHeroSlider.forEach((element) => {
      new Splide(element, {
        heightRatio: 0.428472222,
        cover: true,
        type: "loop",
        perPage: 1,
        autoplay: true,
        mute: true,
        video: {
          loop: true,
        },
        breakpoints: {
          991: {
            heightRatio: 1.713888889,
          },
        },
      }).mount({ Video });
    });

    // Splide sliders
    const splidePartnership = document.querySelectorAll(".splidePartnership");
    // Tambahkan pengecekan
    if (splidePartnership.length > 0) {
      splidePartnership.forEach((element) => {
        try {
          new Splide(element, {
            type: "loop",
            perPage: 6,
            autoplay: true,
            perMove: 1, // 👈 Tambahkan ini untuk slide 1 per 1
            interval: 3000, // Lebih user-friendly
            breakpoints: {
              991: {
                perPage: 3,
              },
            },
          }).mount();
        } catch (error) {
          console.error("Error initializing Splide:", error);
        }
      });
    }

    // Splide sliders
    const splideTestimonySlider = document.querySelectorAll(
      ".splideTestimonySlider"
    );
    splideTestimonySlider.forEach((element) => {
      new Splide(element, {
        autoplay: true,
        type: "loop",
        focus: "center",
        autoWidth: true,
        breakpoints: {
          991: {
            autoWidth: false,
            perPage: 1,
          },
        },
      }).mount();
    });

    // Splide sliders
    const slideAboutTeam = document.querySelectorAll(".slideAboutTeam");
    slideAboutTeam.forEach((element) => {
      new Splide(element, {
        perPage: 1,
        type: "loop",
        gap: "1rem",
      }).mount();
    });

    // Splide sliders
    const articleSlider = document.querySelectorAll(".article__slider");
    articleSlider.forEach((element) => {
      new Splide(element, {
        perPage: 2,
        type: 'loop',
        autoplay: true,
        interval: 2000, // Slides will change every 4 seconds
        gap: "12px",
      }).mount();
    });

    // Splide sliders
    const filterArticle = document.querySelectorAll(".newsUpdateTabs");
    filterArticle.forEach((element) => {
      new Splide(element, {
        perPage: "auto",
        gap: "12px",
      }).mount();
    });
  }

  initAccordions() {
    // Accordion.js
    const accordionsVisiMisi = document.querySelectorAll(
      ".cardVisiMisiAccordion"
    );
    accordionsVisiMisi.forEach((accordion) => {
      // new Accordion(accordion);
      new Accordion(accordion, {
        duration: 400,
        showMultiple: true,
        openOnInit: [0, 1],
      });
    });

    const basicAccordions = document.querySelectorAll(".basicAccordions");
    basicAccordions.forEach((accordion) => {
      // new Accordion(accordion);
      new Accordion(accordion, {
        duration: 400,
        showMultiple: true,
      });
    });

    const faqAccordions = document.querySelectorAll(".faqAccordions");
    faqAccordions.forEach((accordion) => {
      // new Accordion(accordion);
      new Accordion(accordion, {
        duration: 400,
        showMultiple: false,
        openOnInit: [0],
      });
    });

    const accordionsAboutFilosofi =
      document.querySelectorAll(".cardAboutFilosofi");

    accordionsAboutFilosofi.forEach((accordion) => {
      const accordionInstance = new Accordion(accordion, {
        duration: 400,
        showMultiple: false,
      });

      if (!this.isMobile() && !this.isTab()) {
        // Disable click events
        const headers = accordion.querySelectorAll(".ac-header");
        headers.forEach((header) => {
          // Remove click event listeners
          header.replaceWith(header.cloneNode(true));
        });

        // Add hover events
        const newHeaders = accordion.querySelectorAll(".ac-header");
        newHeaders.forEach((header, index) => {
          let hoverTimeout;

          header.addEventListener("mouseenter", () => {
            clearTimeout(hoverTimeout);
            accordionInstance.open(index);
          });

          header.addEventListener("mouseleave", () => {
            hoverTimeout = setTimeout(() => {
              accordionInstance.close(index);
            }, 300);
          });

          // Prevent closing when hovering over content
          const panel = header.nextElementSibling;
          if (panel) {
            panel.addEventListener("mouseenter", () => {
              clearTimeout(hoverTimeout);
            });

            panel.addEventListener("mouseleave", () => {
              hoverTimeout = setTimeout(() => {
                accordionInstance.close(index);
              }, 300);
            });
          }
        });
      }
    });
  }

  // Hapus import Tabby dari atas file
  // import Tabby from 'tabbyjs'; // <-- hapus ini

  initTabs() {
    try {
      const tabContainers = document.querySelectorAll("[data-tabs]");

      if (tabContainers.length === 0) {
        console.log("No tab containers found");
        return;
      }

      tabContainers.forEach((container, index) => {
        this.setupCustomTabs(container, index);
      });

      console.log(
        `✅ Custom tabs initialized for ${tabContainers.length} containers`
      );
    } catch (error) {
      console.error("❌ Error initializing custom tabs:", error);
    }
  }

  setupCustomTabs(container, containerIndex) {
    const triggers = container.querySelectorAll("[data-tabby]");
    const panels = [];

    // Collect all panels
    triggers.forEach((trigger) => {
      const targetId = trigger.getAttribute("data-tabby");
      const panel = document.querySelector(targetId);
      if (panel) {
        panels.push({ trigger, panel, targetId });
      }
    });

    if (panels.length === 0) {
      console.log(
        `No valid tab panels found for container #${containerIndex + 1}`
      );
      return;
    }

    // Setup click handlers
    panels.forEach(({ trigger, panel }, index) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.activateTab(panels, index);
      });

      // Add ARIA attributes for accessibility
      trigger.setAttribute("role", "tab");
      trigger.setAttribute("aria-selected", "false");
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-hidden", "true");
    });

    // Activate first tab
    this.activateTab(panels, 0);
  }

  activateTab(panels, activeIndex) {
    panels.forEach(({ trigger, panel }, index) => {
      const isActive = index === activeIndex;

      // Update trigger state
      trigger.classList.toggle("active", isActive);
      trigger.setAttribute("aria-selected", isActive.toString());

      // Update panel state
      panel.style.display = isActive ? "block" : "none";
      panel.classList.toggle("active", isActive);
      panel.setAttribute("aria-hidden", (!isActive).toString());
    });
  }

  // initNavigation() {
  //   const mobileToggle = document.querySelector(".mobile-menu-toggle");
  //   const mainMenu = document.querySelector(".main-menu");
  //   const menuItemsWithChildren = document.querySelectorAll(
  //     ".menu-item-has-children"
  //   );
  //   const navigation = document.querySelector(".primary-navigation");

  //   // Mobile menu toggle
  //   if (mobileToggle && mainMenu) {
  //     mobileToggle.addEventListener("click", (e) => {
  //       e.preventDefault();
  //       this.toggleMobileMenu(mobileToggle, mainMenu);
  //     });
  //   }

  //   // Mobile submenu toggle with smooth animations
  //   menuItemsWithChildren.forEach((item) => {
  //     const link = item.querySelector("a");
  //     const submenu = item.querySelector(".sub-menu");

  //     if (link && submenu) {
  //       link.addEventListener("click", (e) => {
  //         // Tambahkan class active ke link yang diklik
  //         link.classList.add("active");

  //         // Prevent default dan toggle submenu untuk mobile DAN tablet
  //         if (this.isMobile() || this.isTab()) {
  //           e.preventDefault();
  //           this.toggleSubmenu(item, submenu);
  //         }
  //         // Di desktop, biarkan link navigasi normal
  //       });
  //     }
  //   });

  //   // Close mobile menu when clicking outside - untuk mobile DAN tablet
  //   document.addEventListener("click", (e) => {
  //     if (
  //       (this.isMobile() || this.isTab()) &&
  //       navigation &&
  //       !e.target.closest(".primary-navigation")
  //     ) {
  //       this.closeMobileMenu(mobileToggle, mainMenu, menuItemsWithChildren);
  //     }
  //   });

  //   // Handle window resize
  //   window.addEventListener("resize", () => {
  //     if (!this.isMobile() && !this.isTab()) {
  //       this.resetMobileMenu(mobileToggle, mainMenu, menuItemsWithChildren);
  //     }
  //   });

  //   // Add smooth scroll animation for dropdown menus
  //   this.initDropdownAnimations();
  //   this.initTabView();
  // }

  initNavigation() {
    const mobileToggle = document.querySelector(".mobile-menu-toggle");
    const mainMenu = document.querySelector(".main-menu");
    const menuItemsWithChildren = document.querySelectorAll(
      ".menu-item-has-children"
    );
    const navigation = document.querySelector(".primary-navigation");

    // Mobile menu toggle
    if (mobileToggle && mainMenu) {
      mobileToggle.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleMobileMenu(mobileToggle, mainMenu);
      });
    }

    // Mobile submenu toggle dengan trigger pada ::after area
    menuItemsWithChildren.forEach((item) => {
      const link = item.querySelector("a");
      const submenu = item.querySelector(".sub-menu");

      if (link && submenu) {
        link.addEventListener("click", (e) => {
          const linkRect = link.getBoundingClientRect();
          const clickX = e.clientX - linkRect.left;
          const linkWidth = linkRect.width;

          // Deteksi klik pada area ::after (misal 40px dari kanan)
          const afterAreaWidth = 40; // Sesuaikan dengan lebar ::after Anda
          const isClickOnAfter = clickX > (linkWidth - afterAreaWidth);

          // Hanya trigger jika klik pada area ::after
          if (isClickOnAfter && (this.isMobile() || this.isTab())) {
            e.preventDefault();
            link.classList.add("active");
            this.toggleSubmenu(item, submenu);
          }
          // Jika klik di area teks, biarkan navigasi normal
        });
      }
    });

    // Close mobile menu when clicking outside
    document.addEventListener("click", (e) => {
      if (
        (this.isMobile() || this.isTab()) &&
        navigation &&
        !e.target.closest(".primary-navigation")
      ) {
        this.closeMobileMenu(mobileToggle, mainMenu, menuItemsWithChildren);
      }
    });

    // Handle window resize
    window.addEventListener("resize", () => {
      if (!this.isMobile() && !this.isTab()) {
        this.resetMobileMenu(mobileToggle, mainMenu, menuItemsWithChildren);
      }
    });

    this.initDropdownAnimations();
    this.initTabView();
  }

  initTabView() {
    if (this.isTab()) {
      console.log("tab View");

      // Cek apakah div sudah ada untuk mencegah duplikasi
      let existingMenuTab = document.querySelector(".headerBasic__menuTab");
      if (existingMenuTab) {
        existingMenuTab.remove();
      }

      // Buat div baru dengan class .headerBasic__menuTab
      const newMenuDiv = document.createElement("div");
      newMenuDiv.className = "headerBasic__menuTab";

      // Cari elemen .headerBasic__bottom
      const headerBottom = document.querySelector(".headerBasic__bottom");

      if (headerBottom) {
        // Insert div baru setelah .headerBasic__bottom
        headerBottom.insertAdjacentElement("afterend", newMenuDiv);

        // Cari semua elemen .headerBasic__menu
        const menuSearchElements =
          document.querySelectorAll(".headerBasic__menu");

        // Pindahkan semua .headerBasic__menu ke dalam .headerBasic__menuTab
        menuSearchElements.forEach((element) => {
          newMenuDiv.appendChild(element);
        });
      } else {
        console.warn(".headerBasic__bottom tidak ditemukan");
      }
    }
    if (this.isMobile()) {
      console.log("Mobile View");

      // Cek apakah div sudah ada untuk mencegah duplikasi
      let existingMenuTab = document.querySelector(".headerBasic__menuTab");
      if (existingMenuTab) {
        existingMenuTab.remove();
      }

      // Buat div baru dengan class .headerBasic__menuTab
      const newMenuDiv = document.createElement("div");
      newMenuDiv.className = "headerBasic__menuTab";

      // Cari elemen .headerBasic__bottom
      const headerBottom = document.querySelector(".headerBasic__bottom");

      // Event listener untuk .headerBasic__mobile click
      const mobileToggle = document.querySelector(".headerBasic__mobile");
      if (mobileToggle) {
        mobileToggle.addEventListener("click", (e) => {
          e.preventDefault();
          // Toggle class show pada .headerBasic__menuTab
          newMenuDiv.classList.toggle("show");

          // Toggle scroll hide/show pada body
          document.body.classList.toggle("no-scroll");

          // Scroll to top (0)
          window.scrollTo(0, 0);
        });
      }

      if (headerBottom) {
        // Insert div baru setelah .headerBasic__bottom
        headerBottom.insertAdjacentElement("afterend", newMenuDiv);

        // Cari semua elemen .headerBasic__menu
        const menuSearchElements =
          document.querySelectorAll(".headerBasic__menu");

        // Pindahkan semua .headerBasic__menu ke dalam .headerBasic__menuTab
        menuSearchElements.forEach((element) => {
          newMenuDiv.appendChild(element);
        });

        // Pindahkan .cardLang ke dalam .headerBasic__menu terakhir (paling bawah)
        const cardLangElement = document.querySelector(".cardLang");
        if (cardLangElement && menuSearchElements.length > 0) {
          const lastMenu = menuSearchElements[menuSearchElements.length - 1];
          lastMenu.appendChild(cardLangElement);
        }

        // Buat class baru di dalam .headerBasic__menuTab dengan nama .headerBasic__info
        const infoDiv = document.createElement("div");
        infoDiv.className = "headerBasic__info";

        // Tambahkan .headerBasic__info ke dalam .headerBasic__menuTab
        newMenuDiv.appendChild(infoDiv);

        // Pindahkan .headerBasic__infos ke dalam .headerBasic__info
        const infosElement = document.querySelector(".headerBasic__infos");
        if (infosElement) {
          infoDiv.appendChild(infosElement);
        }

        // Pindahkan .headerBasic__sosmed ke dalam .headerBasic__info
        const sosmedElement = document.querySelector(".headerBasic__sosmed");
        if (sosmedElement) {
          infoDiv.appendChild(sosmedElement);
        }
      } else {
        console.warn(".headerBasic__bottom tidak ditemukan");
      }
    }
  }

  isTab() {
    return window.innerWidth > 992 && window.innerWidth <= 1280;
  }

  isMobile() {
    return window.innerWidth <= 992;
  }

  // YouTube Video Popup functionality
  initVideoPopup() {
    document.querySelectorAll(".nug-video-popup").forEach((video) => {
      video.addEventListener("click", (event) => {
        event.preventDefault();
        this.openVideoPopup(video);
        return false;
      });
    });
  }

  getYoutubeId(url) {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);

    if (match && match[2].length == 11) {
      return match[2];
    } else {
      return "error";
    }
  }

  openVideoPopup(videoElement) {
    // Create HTML elements
    const divPopupWrap = document.createElement("div");
    const divPopupOverlay = document.createElement("div");
    const divPopupContent = document.createElement("div");
    const divPopupClose = document.createElement("div");
    const divPopupInner = document.createElement("div");

    divPopupWrap.className = "nug-video-popup-wrap";
    divPopupOverlay.className = "nug-popup-overlay";
    divPopupContent.className = "nug-video-popup-content";
    divPopupClose.className = "nug-popup-close";
    divPopupInner.className = "nug-popup-inner";

    document.querySelector("body").prepend(divPopupWrap);
    divPopupWrap.appendChild(divPopupOverlay);
    divPopupWrap.appendChild(divPopupContent);
    divPopupContent.appendChild(divPopupClose);
    divPopupContent.appendChild(divPopupInner);

    const youtubeURL = videoElement.closest("a").getAttribute("href");
    const youtubeID = this.getYoutubeId(youtubeURL);
    const youtubeIframe = `<iframe 
        width="100%" 
        height="500" 
        src="https://www.youtube-nocookie.com/embed/${youtubeID}?autoplay=1&rel=0" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen>
      </iframe>`;
    divPopupInner.innerHTML = "";

    const div = document.createElement("div");
    div.innerHTML = youtubeIframe;
    divPopupInner.appendChild(div);

    document.body.classList.add("nug-video-popup-opened");

    // Event listeners for closing popup
    const closePopup = () => {
      document.body.classList.remove("nug-video-popup-opened");
      this.removeVideo(divPopupWrap);
    };

    divPopupOverlay.addEventListener("click", closePopup);
    divPopupClose.addEventListener("click", closePopup);

    // Add ESC key support for closing popup
    const handleEscKey = (e) => {
      if (e.key === "Escape") {
        closePopup();
        document.removeEventListener("keydown", handleEscKey);
      }
    };
    document.addEventListener("keydown", handleEscKey);
  }

  openSearchHeader() {
    const searchTrigger = document.querySelectorAll(".headerBasic__search"); // Gunakan querySelectorAll untuk multiple elements
    const searchForm = document.querySelector(".headerBasic__searchForm");

    // Validasi elemen ada
    if (!searchTrigger.length || !searchForm) {
      console.warn("Search elements not found");
      return;
    }

    searchTrigger.forEach((el, index) => {
      el.addEventListener("click", (e) => {
        e.preventDefault(); // Prevent default action
        searchForm.classList.toggle("active"); // Toggle class active

        // Focus cursor ke input search
        const searchInput = document.querySelector(
          '.headerBasic__searchForm input[name="search"]'
        );
        if (searchInput) {
          searchInput.focus();
        }
      });
    });
  }

  removeVideo(element) {
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  toggleMobileMenu(toggle, menu) {
    toggle.classList.toggle("active");
    menu.classList.toggle("active");

    // GSAP animation for mobile menu
    if (menu.classList.contains("active")) {
      // gsap.fromTo(
      //   menu,
      //   { maxHeight: 0, opacity: 0 },
      //   { maxHeight: "500px", opacity: 1, duration: 0.4, ease: "power2.out" }
      // );
    } else {
      // gsap.to(menu, {
      //   maxHeight: 0,
      //   opacity: 0,
      //   duration: 0.3,
      //   ease: "power2.in",
      // });
    }
  }

  toggleSubmenu(item, submenu) {
    const isActive = item.classList.contains("active");

    // Close other submenus at the same level
    const siblings = item.parentElement.children;
    Array.from(siblings).forEach((sibling) => {
      if (
        sibling !== item &&
        sibling.classList.contains("menu-item-has-children")
      ) {
        sibling.classList.remove("active");
        const siblingSubmenu = sibling.querySelector(".sub-menu");
        if (siblingSubmenu) {
          // gsap.to(siblingSubmenu, {
          //   maxHeight: 0,
          //   duration: 0.3,
          //   ease: "power2.in",
          // });
        }
      }
    });

    // Toggle current submenu
    item.classList.toggle("active");

    if (!isActive) {
      // Opening submenu
      // gsap.fromTo(
      //   submenu,
      //   { maxHeight: auto },
      //   {
      //     // maxHeight: "100%",
      //     backgroundColor: "pink",
      //     // duration: 0.4,
      //     // ease: "power2.out",
      //     // onComplete: () => {
      //     //   submenu.style.maxHeight = "none"; // Allow natural height after animation
      //     // },
      //   }
      // );
    } else {
      // Closing submenu
      // gsap.to(submenu, {
      //   maxHeight: 0,
      //   duration: 0.3,
      //   ease: "power2.in",
      // });
    }
  }

  closeMobileMenu(toggle, menu, menuItems) {
    if (toggle) toggle.classList.remove("active");
    if (menu) menu.classList.remove("active");

    menuItems.forEach((item) => {
      item.classList.remove("active");
      const submenu = item.querySelector(".sub-menu");
      // if (submenu) {
      //   gsap.set(submenu, { maxHeight: 0 });
      // }
    });

    if (menu) {
      // gsap.to(menu, {
      //   maxHeight: 0,
      //   opacity: 0,
      //   duration: 0.3,
      //   ease: "power2.in",
      // });
    }
  }

  resetMobileMenu(toggle, menu, menuItems) {
    if (toggle) toggle.classList.remove("active");
    if (menu) {
      menu.classList.remove("active");
      gsap.set(menu, { maxHeight: "none", opacity: 1 });
    }

    menuItems.forEach((item) => {
      item.classList.remove("active");
      const submenu = item.querySelector(".sub-menu");
      if (submenu) {
        gsap.set(submenu, { maxHeight: "none" });
      }
    });
  }

  initDropdownAnimations() {
    const menuItems = document.querySelectorAll(".menu-item-has-children");

    menuItems.forEach((item) => {
      const submenu = item.querySelector(".sub-menu");
      if (submenu && !this.isMobile()) {
        item.addEventListener("mouseenter", () => {
          // if (!this.isMobile()) {
          //   gsap.fromTo(
          //     submenu,
          //     {
          //       opacity: 0,
          //       y: -10,
          //       scale: 0.95,
          //     },
          //     {
          //       opacity: 1,
          //       y: "-12px",
          //       scale: 1,
          //       duration: 0.3,
          //       ease: "power2.out",
          //     }
          //   );
          // }
        });

        item.addEventListener("mouseleave", () => {
          // if (!this.isMobile()) {
          //   gsap.to(submenu, {
          //     opacity: 0,
          //     y: -10,
          //     scale: 0.95,
          //     duration: 0.2,
          //     ease: "power2.in",
          //   });
          // }
        });
      }
    });
  }

  // Tambahkan ke initializeComponents()
  initDownloadLinks() {
    try {
      const downloadLinks = document.querySelectorAll("a[download]");

      downloadLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          const url = link.getAttribute("href");
          const filename = link.getAttribute("download");

          // Check if it's cross-origin
          if (!url.startsWith(window.location.origin)) {
            e.preventDefault();
            this.handleCrossOriginDownload(url, filename);
          }
        });
      });

      console.log(`✅ Download links initialized: ${downloadLinks.length}`);
    } catch (error) {
      console.error("❌ Error initializing download links:", error);
    }
  }

  handleCrossOriginDownload(url, filename) {
    // Try different methods
    Promise.resolve()
      .then(() => {
        // Method 1: Try fetch
        return fetch(url).then((response) => {
          if (!response.ok) throw new Error("Fetch failed");
          return response.blob();
        });
      })
      .then((blob) => {
        // Success: Create download
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {
        console.warn("Direct download failed, opening in new tab:", error);
        // Fallback: Open in new tab
        window.open(url, "_blank");
      });
  }

  // ✅ MODAL FUNCTIONALITY - Tambahkan fungsi modal di sini
  initModal() {
    try {
      // Buat modal container
      this.createModalContainer();

      // Setup event listeners
      this.setupModalEventListeners();

      console.log("✅ Modal system initialized");
    } catch (error) {
      console.error("❌ Error initializing modal:", error);
    }
  }

  createModalContainer() {
    // Cek apakah modal container sudah ada
    if (document.getElementById("modalContainer")) {
      return;
    }

    const modalHTML = `
      <div id="modalContainer" class="modal-overlay" style="display: none;">
        <div class="modal-content">
          <div class="modal-close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div id="modalBody" style="width:100%"></div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHTML);
  }

  setupModalEventListeners() {
    // Event listener untuk membuka dan menutup modal
    document.addEventListener("click", (e) => {
      // Buka modal
      const trigger = e.target.closest("[data-modal-name]");
      if (trigger) {
        e.preventDefault();
        this.openModal(trigger);
        return;
      }

      // Tutup modal
      if (
        e.target.classList.contains("modal-close") ||
        e.target.closest(".modal-close") ||
        e.target.id === "modalContainer"
      ) {
        this.closeModal();
      }
    });

    // Tutup modal dengan ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.closeModal();
      }
    });
  }

  initIntl(scope = document) {
    // console.log("International Telephone Input");

    const countryFormats = {
      id: {
        // Indonesia
        pattern: "XXX-XXXX-XXXX",
        format: (num) => num.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3"),
        maxLength: 12,
      },
      us: {
        // USA
        pattern: "XXX-XXX-XXXX",
        format: (num) => num.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"),
        maxLength: 10,
      },
      gb: {
        // UK
        pattern: "XXXX-XXX-XXXX",
        format: (num) => num.replace(/(\d{4})(\d{3})(\d{4})/, "$1-$2-$3"),
        maxLength: 11,
      },
      my: {
        // Malaysia
        pattern: "XX-XXXX-XXXX",
        format: (num) => num.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3"),
        maxLength: 10,
      },
      sg: {
        // Singapore
        pattern: "XXXX-XXXX",
        format: (num) => num.replace(/(\d{4})(\d{4})/, "$1-$2"),
        maxLength: 8,
      },
    };

    const formatPhoneNumber = (value, countryCode) => {
      const digits = value.replace(/\D/g, "");
      const format = countryFormats[countryCode];
      if (!format) return digits;

      const limitedDigits = digits.substring(0, format.maxLength);
      return format.format(limitedDigits);
    };

    const setupPhoneInput = (phoneInput) => {
      if (phoneInput.itiInstance) {
        console.log("Phone input already initialized, skipping...");
        return phoneInput.itiInstance;
      }

      // console.log("Initializing new phone input...");

      // ✅ Pastikan element visible sebelum init
      const isVisible = phoneInput.offsetParent !== null;
      if (!isVisible) {
        // console.warn("Phone input not visible, waiting...");
        setTimeout(() => setupPhoneInput(phoneInput), 100);
        return;
      }

      const iti = intlTelInput(phoneInput, {
        initialCountry: "id",
        separateDialCode: true,
        preferredCountries: ["id", "us", "gb", "my", "sg"],
        utilsScript:
          "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
        autoFormat: false,
        autoPlaceholder: "off",
      });

      let isFormatting = false;

      // ✅ PERBAIKAN: Update placeholder dengan benar
      const updatePlaceholder = () => {
        const countryData = iti.getSelectedCountryData();
        const format = countryFormats[countryData.iso2];

        if (format) {
          phoneInput.placeholder = format.pattern;
          console.log(
            `Updated placeholder for ${countryData.iso2}:`,
            format.pattern
          );
        } else {
          phoneInput.placeholder = "Enter phone number";
        }
      };

      const handleInput = (e) => {
        if (isFormatting) return;
        isFormatting = true;

        const countryData = iti.getSelectedCountryData();
        const formattedValue = formatPhoneNumber(
          e.target.value,
          countryData.iso2
        );
        e.target.value = formattedValue;

        isFormatting = false;
      };

      const handleCountryChange = () => {
        console.log("Country changed, updating placeholder...");
        updatePlaceholder();

        if (phoneInput.value) {
          const countryData = iti.getSelectedCountryData();
          phoneInput.value = formatPhoneNumber(
            phoneInput.value,
            countryData.iso2
          );
        }
      };

      const handlePaste = (e) => {
        e.preventDefault();
        const pastedText = (e.clipboardData || window.clipboardData).getData(
          "text"
        );
        const countryData = iti.getSelectedCountryData();
        phoneInput.value = formatPhoneNumber(pastedText, countryData.iso2);
      };

      // Add event listeners
      phoneInput.addEventListener("input", handleInput);
      phoneInput.addEventListener("countrychange", handleCountryChange);
      phoneInput.addEventListener("paste", handlePaste);

      // Store handlers
      phoneInput._eventHandlers = {
        input: handleInput,
        countrychange: handleCountryChange,
        paste: handlePaste,
      };

      // ✅ PENTING: Set placeholder setelah init
      setTimeout(() => {
        updatePlaceholder();
      }, 100);

      phoneInput.itiInstance = iti;
      return iti;
    };

    const phoneInputs = scope.querySelectorAll(".phone-input");
    console.log(`Found ${phoneInputs.length} phone inputs in scope`);

    phoneInputs.forEach((phoneInput) => {
      try {
        setupPhoneInput(phoneInput);
      } catch (error) {
        console.error("Error initializing phone input:", error);
      }
    });

    // Setup global functions hanya sekali
    if (!window.getPhoneData) {
      window.getPhoneData = (inputElement) => {
        if (!inputElement || !inputElement.itiInstance) {
          console.error("Invalid phone input element or not initialized");
          return null;
        }

        const iti = inputElement.itiInstance;
        return {
          formatted: inputElement.value,
          clean: inputElement.value.replace(/\D/g, ""),
          international: iti.getNumber(),
          isValid: iti.isValidNumber(),
          country: iti.getSelectedCountryData(),
        };
      };

      window.getAllPhoneData = () => {
        const allInputs = document.querySelectorAll(".phone-input");
        const allData = [];
        allInputs.forEach((input, index) => {
          const data = window.getPhoneData(input);
          if (data) {
            allData.push({
              index: index,
              element: input,
              id: input.id || `phone-${index}`,
              ...data,
            });
          }
        });
        return allData;
      };

      window.getPhoneDataById = (selector) => {
        const element = document.querySelector(selector);
        return window.getPhoneData(element);
      };
    }
  }
  openModal(trigger) {
    const modalData = trigger.querySelector("[data-modal-data]");
    const modalContainer = document.getElementById("modalContainer");
    const modalBody = document.getElementById("modalBody");

    if (!modalData || !modalContainer || !modalBody) {
      console.warn("Modal elements not found");
      return;
    }

    try {
      // Clone content dan tampilkan
      const content = modalData.cloneNode(true);
      content.style.display = "block";

      // Clear dan isi modal body
      modalBody.innerHTML = "";
      modalBody.appendChild(content);

      // ✅ PERBAIKAN: Init intl SEBELUM animasi
      const hasPhoneInput = modalBody.querySelector(".phone-input");
      if (hasPhoneInput) {
        console.log(
          "📞 Phone input detected, initializing before animation..."
        );

        // Init dengan delay minimal
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.initIntl(modalBody);
          });
        });
      }

      // Tampilkan modal dengan animasi
      modalContainer.style.display = "flex";

      // GSAP animation untuk modal
      gsap.fromTo(
        modalContainer,
        { opacity: 0 },
        { opacity: 1, duration: 0.3, ease: "power2.out" }
      );

      gsap.fromTo(
        modalContainer.querySelector(".modal-content"),
        { scale: 0.8, y: 50 },
        { scale: 1, y: 0, duration: 0.3, ease: "power2.out" }
      );

      console.log("✅ Modal opened");
    } catch (error) {
      console.error("❌ Error opening modal:", error);
    }
  }

  closeModal() {
    const modalContainer = document.getElementById("modalContainer");
    const modalBody = document.getElementById("modalBody");

    if (!modalContainer) {
      return;
    }

    try {
      // GSAP animation untuk menutup modal
      gsap.to(modalContainer, {
        opacity: 0,
        duration: 0.2,
        ease: "power2.in",
        onComplete: () => {
          modalContainer.style.display = "none";

          // Clear modal body
          if (modalBody) {
            modalBody.innerHTML = "";
          }
        },
      });

      console.log("✅ Modal closed");
    } catch (error) {
      console.error("❌ Error closing modal:", error);
    }
  }

  // ✅ CAROUSEL FUNCTIONALITY - Tambahan untuk TongkolspaceApp
  initCarousel() {
    if (!this.isMobile()) {
      try {
        const containers = document.querySelectorAll(".coruselSimple");

        if (containers.length === 0) {
          console.log("No carousel containers found");
          return;
        }

        containers.forEach((container) => {
          this.setupCarousel(container);
        });

        console.log(
          `✅ Carousel initialized for ${containers.length} containers`
        );
      } catch (error) {
        console.error("❌ Error initializing carousel:", error);
      }
    }
  }

  setupCarousel(container) {
    const ul = container.querySelector("ul");
    if (!ul) return;

    // Wrap ul dengan carousel wrapper
    const wrapper = document.createElement("div");
    wrapper.className = "carousel-wrapper";
    ul.parentNode.insertBefore(wrapper, ul);
    wrapper.appendChild(ul);

    let currentPosition = 0;

    // Create arrows
    const leftArrow = document.createElement("button");
    leftArrow.className = "carousel-arrow left";
    // leftArrow.innerHTML = ' ';

    const rightArrow = document.createElement("button");
    rightArrow.className = "carousel-arrow right";
    // rightArrow.innerHTML = ' ';

    container.appendChild(leftArrow);
    container.appendChild(rightArrow);

    const checkArrows = () => {
      const containerWidth = wrapper.offsetWidth;
      const totalWidth = ul.scrollWidth;

      if (totalWidth > containerWidth) {
        leftArrow.classList.toggle("show", currentPosition > 0);
        rightArrow.classList.toggle(
          "show",
          currentPosition < totalWidth - containerWidth
        );
      } else {
        leftArrow.classList.remove("show");
        rightArrow.classList.remove("show");
      }
    };

    const scrollCarousel = (direction) => {
      const itemWidth = 105; // 100px + 5px margin
      const containerWidth = wrapper.offsetWidth;
      const totalWidth = ul.scrollWidth;

      if (direction === "left") {
        currentPosition = Math.max(0, currentPosition - itemWidth);
      } else {
        currentPosition = Math.min(
          totalWidth - containerWidth,
          currentPosition + itemWidth
        );
      }

      ul.style.transform = `translateX(-${currentPosition}px)`;
      checkArrows();
    };

    leftArrow.onclick = () => scrollCarousel("left");
    rightArrow.onclick = () => scrollCarousel("right");

    // Initialize
    checkArrows();

    // Handle window resize
    window.addEventListener("resize", checkArrows);
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new TongkolspaceApp();
});

// Export for global access if needed
window.TongkolspaceApp = TongkolspaceApp;
